import BaseAnimationAction from "./baseAnimationAction";

class PauseAnimation extends BaseAnimationAction {
    constructor(props) {
        super(props);
    }

    async execute({training}) {
        const branchId = this.getBranchId(training);
        AnimationPlayer.pause(this.meshType, branchId);
    }
}

export default PauseAnimation;